import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Router from "../../routes/route";
import { Box, Tab, Tabs } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CallIcon from "@mui/icons-material/Call";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import PhoneDisabledIcon from "@mui/icons-material/PhoneDisabled";
import ReceiptIcon from "@mui/icons-material/Receipt";
import RingVolumeIcon from "@mui/icons-material/RingVolume";
import AvTimerIcon from "@mui/icons-material/AvTimer";
import HistoryIcon from "@mui/icons-material/History";

const tabConfig = {
  dashboard: {
    label: "Dashboard",
    icon: <DashboardIcon />,
    path: Router.REDIRECT_DASHBOARD,
  },
  manage_campaign: {
    label: "Manage Campaign",
    icon: <CallIcon />,
    path: Router.REDIRECT_CAMPAIGNS,
  },
  did_tfn_number: {
    label: "DID/TFN NUMBER",
    icon: <ReceiptIcon />,
    path: Router.REDIRECT_DESTINATION,
  },
  report: {
    label: "Report",
    icon: <HelpOutlineIcon />,
    path: Router.REDIRECT_XML_CDR,
  },
  call_block: {
    label: "Call Block",
    icon: <PhoneDisabledIcon />,
    path: Router.REDIRECT_CALL_BLOCK,
  },
  active_calls: {
    label: "Active Calls",
    icon: <RingVolumeIcon />,
    path: Router.REDIRECT_CALL_ACTIVE,
  },
  minutes_log: {
    label: "Minutes Log",
    icon: <AvTimerIcon />,
    path: Router.REDIRECT_MINUTES_LOG,
  },
  activity_log: {
    label: "Activity Log",
    icon: <HistoryIcon />,
    path: Router.REDIRECT_ACTIVITY_LOG,
  },
};

function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const current_user = localStorage.getItem("current_user");
  const user = JSON.parse(localStorage.getItem(`user_${current_user}`));

  const tabOrder = Object.keys(tabConfig);

  const availableTabs = (user?.blocked_features || [])
    .filter((key) => tabConfig[key])
    .sort((a, b) => tabOrder.indexOf(a) - tabOrder.indexOf(b));

  const tabPaths = availableTabs.map((key) => tabConfig[key]?.path);

  // ✅ Get initial tab based on pathname or localStorage key
  const getInitialTab = () => {
    const storedKey = localStorage.getItem("selectedTabKey");

    if (storedKey) {
      const index = availableTabs.indexOf(storedKey);
      if (index !== -1) return index;
    }

    const currentIndex = tabPaths.findIndex(
      (path) => path === location.pathname
    );
    return currentIndex !== -1 ? currentIndex : 0;
  };

  const [value, setValue] = useState(getInitialTab);

  // ✅ Sync tab selection to localStorage key-based
 useEffect(() => {
  const currentPathIndex = tabPaths.findIndex(
    (path) => path === location.pathname
  );
  if (currentPathIndex !== -1) {
    setValue(currentPathIndex);
  }
}, [location.pathname]);

  const handleTabChange = (event, newValue) => {
  setValue(newValue);
  localStorage.setItem("selectedTabKey", availableTabs[newValue]);
  navigate(tabPaths[newValue]);
};

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{ borderBottom: 1, borderColor: "divider" }}
        className="redirect_header_row"
      >
        <Tabs
          value={value}
          onChange={handleTabChange}
          aria-label="Navigation Tabs"
          className="redirect_tab"
          sx={{
              "& .Mui-selected": {
        backgroundColor: "#f97316", // 🔥 orange
        color: "#fff !important",
      },

      "& .MuiTabs-indicator": {
        display: "none", // remove default underline
      },
          }}
        >
          {availableTabs.map((key) => (
            <Tab
              key={key}
              label={tabConfig[key]?.label}
              icon={tabConfig[key]?.icon } 
              className="tabbs"
              
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
}

export default Navbar;
